import { REQUEST_SOURCE_MEDIA_FOR_PREVIEW, RECEIVE_SOURCE_MEDIA_FOR_PREVIEW, CLEAR_SOURCE_MEDIA_PREVIEW_VALUES } from '../constants/actionTypes';
import { displayError } from './helpers';

// Action Creators
const requestSourceMediaForPreview = () => ({
    type: REQUEST_SOURCE_MEDIA_FOR_PREVIEW
});

const recieveSourceMediaForPreview = (previewData, sourceUrl) => ({
    type: RECEIVE_SOURCE_MEDIA_FOR_PREVIEW,
    previewData: previewData,
    sourceUrl: sourceUrl
});

export const clearSourceMediaPreviewValues = () => ({
    type: CLEAR_SOURCE_MEDIA_PREVIEW_VALUES
});

// Action Logic
const shouldFetchSourceMedia = (state, mediaUrl) => {
    return !state.isFetchingPreviewData && state.sourceUrl !== mediaUrl;
};

const readBlob = blob => {
    return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.addEventListener('loadend', () => {
            resolve(reader.result);
        });
        reader.addEventListener('error', () => {
            reject('failed to read downloaded blob');
        });
        reader.readAsArrayBuffer(blob);
    });
};

const fetchSourceMedia = mediaUrl => (dispatch) => {
    dispatch(requestSourceMediaForPreview());
    return fetch(mediaUrl)
        .then(resp => resp.ok ? resp.blob() : Promise.reject(resp.body))
        .then(readBlob)
        .then(buffer => dispatch(recieveSourceMediaForPreview(buffer, mediaUrl)));
};

export const fetchSourceMediaFileIfOK = mediaURL => (dispatch, getState) => {
    const previewState = getState().ui.previewMedia;

    if (shouldFetchSourceMedia(previewState, mediaURL)) {
        return dispatch(fetchSourceMedia(mediaURL))
            .catch(err => {
                dispatch(clearSourceMediaPreviewValues);
                dispatch(displayError(err));
            }
        );
    }
};



// WEBPACK FOOTER //
// ./src/actions/fetchSourceMediaFile.js